import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Input, Form, FormGroup, Button, Spinner, Alert } from "reactstrap";
import { useAuth } from "../../contexts/AuthContext";
import Logo from "../../assets/img/HT-Logo-Wordmark.svg";
import "./login.scss";

function LoginPage() {
  const { login, loading, authenticated } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if this is a password reset callback
    const searchParams = new URLSearchParams(location.search);
    const resetKey = searchParams.get("resetKey");
    const email = searchParams.get("email");

    if (resetKey && email) {
      // Redirect to change password page with query params
      navigate(`/login/change-password?resetKey=${resetKey}&email=${email}`);
      return;
    }

    if (authenticated) {
      const redirectPath = searchParams.get("go2") || "/";
      navigate(redirectPath);
    }
  }, [authenticated, navigate, location]);

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const j_username = e.target.elements.j_username.value;
    const j_password = e.target.elements.j_password.value;

    if (!j_username || !j_password) {
      setError("Please enter username and password");
      return;
    }

    const result = await login({
      username: j_username,
      password: j_password,
    });

    if (!result.success) {
      setError(result.error || "Login failed");
    }
  };

  const showResetPassword = () => {
    navigate("/login/forgot-password");
  };

  return (
    <div style={{ marginTop: "3rem" }} className="wrapper fadeInDown">
      <div id="formContent">
        <div className="fadeIn first">
          <img src={Logo} id="icon" alt="User Icon" />
        </div>

        {error && (
          <>
            <br />
            <Alert
              color="danger"
              className="login-container-padding m-d-20"
            >
              {error}
            </Alert>
          </>
        )}
        <br />

        <Form
          className="login-container-padding"
          onSubmit={handleOnSubmit}
          method="post"
        >
          <FormGroup>
            <Input
              readOnly={loading}
              type="text"
              id="login"
              className="fadeIn second"
              name="j_username"
              placeholder="User name"
              autoComplete="username"
            />
          </FormGroup>
          <FormGroup>
            <Input
              readOnly={loading}
              type="password"
              id="password"
              className="fadeIn third"
              name="j_password"
              placeholder="Password"
              required
              autoComplete="current-password"
            />
          </FormGroup>
          <Button
            type="submit"
            className="fadeIn fourth"
            color="primary"
            disabled={loading}
            required
          >
            {loading ? <Spinner size="sm" /> : "Log In"}
          </Button>
        </Form>

        <div id="formFooter">
          <Button
            className="underlineHover"
            onClick={showResetPassword}
            color="link"
          >
            Forgot Password?
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
